<template>
    <Button icon="pi pi-comments" :class="['p-button-text btn', roleClass]"
        style="height: 30px; width: 30px; padding: 0;" @click.stop="initiateChat" />
</template>

<script setup>
import { defineProps, defineEmits, computed } from 'vue';
import Button from 'primevue/button';
import { useAuthStore } from "@/stores/authStore";
import { useChatStore } from "@/stores/chatStore";

const props = defineProps({
    otherUserId: {
        type: String,
        required: true
    },
    otherUserName: {
        type: String,
        required: true
    }
});

const emit = defineEmits(['open-chat']);
const authStore = useAuthStore();
const chatStore = useChatStore();

const roleClass = computed(() => {
    return authStore.user?.role === 'tutor' ? 'role-tutor' : 'role-student';
});

const initiateChat = async () => {
    if (!authStore.user || !authStore.user.userId) return;

    const channel = await chatStore.startChat(
        authStore.user.userId,
        props.otherUserId,
        props.otherUserName
    );

    if (channel) {
        emit('open-chat', channel);
    }
};
</script>
<style scoped>
.role-student {
    color: var(--orange-500) !important;
}

.role-student:hover,
.role-student:active {
    background-color: rgba(255, 0, 0, 0.1) !important;
}

.role-tutor {
    color: var(--teal-500) !important;
}

.role-tutor:hover,
.role-tutor:active {
    background-color: rgba(0, 128, 128, 0.1) !important;
}
</style>